import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';

export const styledBackstageItemCardHeader = (
  theme: Theme,
): BackstageOverrides['BackstageItemCardHeader'] => ({
  root: {
    backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
    borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,
    color: `${theme.palette.common.white} !important`,
  },
});
